import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  return (
    <div className="bg-surface rounded-xl p-8 border border-border">
      <h3 className="text-xl font-jakarta font-semibold text-text-primary mb-6 flex items-center">
        <Icon name="MessageCircle" size={24} className="text-primary mr-3" />
        Privacy Questions?
      </h3>
      
      <div className="space-y-4">
        <div className="flex items-start space-x-3">
          <Icon name="Mail" size={20} className="text-text-secondary mt-1" />
          <div>
            <p className="font-medium text-text-primary">Email Us</p>
            <p className="text-text-secondary">privacy@openbooq.com</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <Icon name="Phone" size={20} className="text-text-secondary mt-1" />
          <div>
            <p className="font-medium text-text-primary">Call Us</p>
            <p className="text-text-secondary">(937) 910-8791</p>
          </div>
        </div>
        
        <div className="flex items-start space-x-3">
          <Icon name="MapPin" size={20} className="text-text-secondary mt-1" />
          <div>
            <p className="font-medium text-text-primary">Mail Us</p>
            <p className="text-text-secondary">
              OpenbooQ Privacy Team<br />
              123 Transparency Lane<br />
              Austin, TX 78701
            </p>
          </div>
        </div>
      </div>

      <p className="mt-6 text-sm text-text-secondary leading-relaxed">
        By texting us, you agree to receive SMS/MMS messages from OpenbooQ. Message and data rates may apply. Message frequency varies. Reply STOP to opt-out, HELP for help. View our{' '}
        <Link to="/privacy-policy" className="text-primary underline hover:text-primary/80">Privacy Policy</Link>
        {' '}and{' '}
        <Link to="/terms-of-service" className="text-primary underline hover:text-primary/80">Terms of Service</Link>.
      </p>
    </div>
  );
};

export default ContactInfo;